interface DeepThoughtsInteractionThumbnailProps {
  entityId: string;
}

export function DeepThoughtsInteractionThumbnail({
  entityId: _entityId,
}: DeepThoughtsInteractionThumbnailProps) {
  return (
    <div
      className="flex h-14 w-10 shrink-0 items-center justify-center overflow-hidden rounded-sm bg-brand-darkMaroon shadow-sm"
      aria-hidden
    >
      <div className="h-8 w-8 rotate-[21deg] rounded-full bg-brand-apricot opacity-90" />
    </div>
  );
}
